module.exports = __webpack_public_path__ + "static/documentsearch-44a30daeff28d9ae436409c3273f0869.png";